import React from 'react'

const PrimeEcoPower = React.lazy(() => import('./views/pages/PrimeEcoPower.js'))
const Solutions = React.lazy(() => import('./views/pages/Solutions.js'))
const ShowCase = React.lazy(() => import('./views/pages/ShowCase.js'))
const Contact = React.lazy(() => import('./views/pages/Contact.js'))
const ErrorPage = React.lazy(() => import('./views/pages/ErrorPage.js'))
const routes = [
  { path: '/', exact: true, name: 'Home', element: PrimeEcoPower },
  { path: '/solutions.html', name: 'solutions', element: Solutions },
  { path: '/showcase.html', name: 'showcase', element: ShowCase },
  { path: '/contact.html', name: 'contact', element: Contact },
  { path: '*', name: '404', element: ErrorPage },
]

export default routes
